// PLACEHOLDER testimonials for the Commercial & Industrial tracks.
//
// =====================================================================
// SAMPLE TESTIMONIALS — REPLACE WITH REAL CLIENT QUOTES BEFORE LAUNCH
// =====================================================================
// There are no real commercial/industrial client reviews on file yet, so
// these are representative samples written in a property-manager / site-
// supervisor voice, addressed to "Reformity Inc." (not the founder).
// They use role + property-type + city only — NO invented personal names or
// company names — and are intentionally NOT marked "verified".
// Swap these for genuine client testimonials (with permission) before going
// live. See REBUILD_PLAN.md §2 (review-data honesty).
// =====================================================================

export const COMMERCIAL_TESTIMONIALS = [
    {
        id: "com-placeholder-1",
        quote: "Reformity Inc. resurfaced the parking lots across three of our retail sites with zero disruption to tenants — work was scheduled after hours and every COI was on file before they mobilized.",
        name: "Property Manager",
        role: "Retail Portfolio · Mississauga",
        rating: 5,
        placeholder: true,
    },
    {
        id: "com-placeholder-2",
        quote: "We moved most of our exterior maintenance to Reformity Inc. One point of contact, documented sign-offs, and predictable pricing across the portfolio — exactly what we needed.",
        name: "Asset Manager",
        role: "Multi-Site Office · Toronto",
        rating: 5,
        placeholder: true,
    },
    {
        id: "com-placeholder-3",
        quote: "Their crew kept our plaza entrances open and clean throughout the concrete and walkway repairs. Reformity Inc. communicated every phase and finished on schedule.",
        name: "Property Manager",
        role: "Mixed-Use Property · Vaughan",
        rating: 5,
        placeholder: true,
    },
    {
        id: "com-placeholder-4",
        quote: "WSIB clearance, insurance, and a clear scope came back the same week we asked. Reformity Inc. made the approval process easy for our board.",
        name: "Property Administrator",
        role: "Condominium Corporation · Brampton",
        rating: 5,
        placeholder: true,
    },
];

export const INDUSTRIAL_TESTIMONIALS = [
    {
        id: "ind-placeholder-1",
        quote: "Reformity Inc. specified truck-rated asphalt for our yard and phased the work around shipping. No downtime, and the lot is holding up under daily trailer traffic.",
        name: "Site Supervisor",
        role: "Distribution Centre · Brampton",
        rating: 5,
        placeholder: true,
    },
    {
        id: "ind-placeholder-2",
        quote: "Loading dock apron and bollard work was done to spec, with full compliance documentation handed over at close-out. Reformity Inc. understood our safety requirements.",
        name: "Facility Manager",
        role: "Warehouse · Mississauga",
        rating: 5,
        placeholder: true,
    },
    {
        id: "ind-placeholder-3",
        quote: "We needed security fencing and access-controlled gates across a large site. Reformity Inc. scheduled around our 24/7 operations and kept the yard secure throughout.",
        name: "Operations Manager",
        role: "Logistics Facility · Vaughan",
        rating: 5,
        placeholder: true,
    },
    {
        id: "ind-placeholder-4",
        quote: "Structural concrete repairs were completed during our shutdown window exactly as planned. Reformity Inc. is now our first call for site work.",
        name: "Plant Maintenance Lead",
        role: "Manufacturing Facility · Hamilton",
        rating: 5,
        placeholder: true,
    },
];

export const TRACK_TESTIMONIALS = {
    commercial: COMMERCIAL_TESTIMONIALS,
    industrial: INDUSTRIAL_TESTIMONIALS,
};
